module.exports = __webpack_public_path__ + "static/0019-6e62d231c24485f3075672c2c8bae894.png";